module.exports = __webpack_public_path__ + "img/numeralia_cedis_5.67637473.svg";